import React from "react";
import RedirectTo from "components/RedirectTo/RedirectTo";
import { useSlc, RootState } from "app/store";
import { SubNav } from "components/nav";
import { WrapperWishLists } from "app/wrappers";
import { wishlistLinks } from "app/constants";
import { Scrollbar } from "components/scrollbar/";

export const WishLists = () => {
  const isAuth = useSlc((state: RootState) => state.user.isAuth);

  if (isAuth)
    return (
      <>
        <Scrollbar className="subnav__scroll-x">
          <SubNav links={wishlistLinks} />
        </Scrollbar>
        <WrapperWishLists />
      </>
    );
  return <RedirectTo path="/sign-in" />;
};
